import {
  MOBILE,
  // FIXED,
} from 'AppSrc/core/components/forms/value-dependency-constants';


import mobileServicesJson from './mobile_services.json';
import fixedServicesJson from './fixed_services.json';


const getProdCatsForServices = ({
  value,
  selectedNetwork,
}) => {

  const prodCats = selectedNetwork === MOBILE ? mobileServicesJson[value] : fixedServicesJson[value];

  if (!prodCats) {
    console.warn(`cannot find prodcats for service: ${value}`);
    return [null, null, null];
  }

  // services contains some empty strings, we don't want this.
  const formattedProdCats = prodCats.map((prodCat) => (prodCat === '' ? null : prodCat));

  // we expect this return an array containing 3 values (one for each prodCat tier).
  // however the fixed mapping was never implemented properly by vodafone and so
  // we just add nulls to the empty array until there are three values
  for (let index = formattedProdCats.length; formattedProdCats.length < 3; index++) {
    formattedProdCats.push(null);
  }

  return formattedProdCats;
};

export {
  getProdCatsForServices,
};
